/*!

=========================================================
* Argon Design System React - v1.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardImg,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Hero from "../IndexSections/Hero.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import { setPageMeta } from "utils/seo.js";

class Landing extends React.Component {
  componentDidMount() {
    setPageMeta({
      title: "Data Consulting & IoT Monitoring",
      description:
        "Chisp builds the data systems your operation runs on: cloud data consulting on AWS, Snowflake and Databricks, plus IoT monitoring hardware and dashboards.",
      path: "/",
    });
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
        <Hero />
          <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="9">
                  <h2 className="display-3">Two ways we work with data</h2>
                  <p className="lead text-muted">
                    Chisp is a data company with two branches. Our consulting practice designs
                    and modernizes the cloud data platforms organizations run on, and our IoT
                    division builds the connected hardware and software that captures data at
                    the source. Many clients use one. Some use both.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid">
                <Col lg="6">
                  <Card className="shadow border-0 h-100">
                    <CardBody className="py-5">
                      <div className="icon icon-lg icon-shape icon-shape-primary rounded-circle mb-4">
                        <i className="fa fa-database" />
                      </div>
                      <h6 className="text-primary text-uppercase ls-1 mb-2">Consulting</h6>
                      <h4>Data Consulting</h4>
                      <p className="description mt-3">
                        Cloud data architecture, warehousing, analytics, and custom applications.
                        We build on AWS, Snowflake, Databricks, and Power BI, and we train your
                        team to run what we deliver.
                      </p>
                      <ul className="list-unstyled mt-3">
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Cloud data architecture &amp; warehousing
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Analytics, dashboards &amp; reporting
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Machine learning &amp; image analysis
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Custom applications &amp; internal tools
                        </li>
                      </ul>
                      <Button
                        className="btn-round mt-4"
                        color="primary"
                        to="/consulting"
                        tag={Link}
                      >
                        Explore Data Consulting
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="6">
                  <Card className="shadow border-0 h-100">
                    <CardBody className="py-5">
                      <div className="icon icon-lg icon-shape icon-shape-success rounded-circle mb-4">
                        <i className="fa fa-sitemap" />
                      </div>
                      <h6 className="text-success text-uppercase ls-1 mb-2">Product</h6>
                      <h4>IoT Platform &amp; Devices</h4>
                      <p className="description mt-3">
                        The Chisp Hub and dashboard: connected sensors, cameras, and devices with
                        AI-powered monitoring and real-time alerting across industrial, commercial,
                        and residential sites.
                      </p>
                      <ul className="list-unstyled mt-3">
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Industrial monitoring &amp; safety
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Home connectivity &amp; automation
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Real-time alerts &amp; device management
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Platform analytics dashboards
                        </li>
                      </ul>
                      <Button
                        className="btn-round mt-4"
                        color="success"
                        to="/platform"
                        tag={Link}
                      >
                        Explore the IoT Platform
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section bg-white">
            <Container>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="Illustration of connected devices linked to a central hub"

                      src={require("assets/img/theme/hub.jpg")}

                      top
                    />
                    <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">

                        From a sensor on the wall to the board report
                      </h4>
                      <p className="lead text-italic text-white">
                      One team across the hardware, the pipelines, and the dashboards on top

                      </p>
                    </blockquote>
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-4">
                      <i className="ni ni-button-power" />
                    </div>
                    <h3>Our Story</h3>
                    <p className="lead">
                      Most organizations do not have a data problem so much as a plumbing
                      problem. The information already exists &mdash; in a warehouse, a
                      spreadsheet, a camera feed, a sensor on a wall &mdash; but it never
                      arrives anywhere useful.
                    </p>
                    <p>
                      Chisp started because the same skills fix both ends of that. Someone has
                      to design the pipeline and the warehouse. Someone has to build the device
                      that produces the reading in the first place. We do both, which is why our
                      consulting practice and our IoT products share one engineering team.
                    </p>
                    <p>
                      In practice that means we might spend one month refactoring ETL pipelines
                      and standing up Snowflake for a healthcare client, and the next installing
                      camera systems on a transit work site. Same people, same standards.{" "}
                      <strong>One platform, infinite insight.</strong>
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg bg-gradient-default">
            <Container>
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Why Chisp?</h2>
                  <p className="lead text-white">
                    We build our own hardware and run our own platform, and we take that
                    same engineering into client work. It means one team can follow a
                    problem from a sensor on a wall to a number on a board report.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid mt-5">
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-plug text-primary" />
                    </div>
                    <h4 className="text-white mt-3">Hardware to Dashboard</h4>
                    <p className="text-white mt-3">
                      Sensors, ingestion, warehouse, and reporting are one continuous
                      system to us, not four vendors pointing at each other.
                    </p>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-users text-primary" />
                    </div>
                    <h4 className="text-white mt-3">A Small Senior Team</h4>
                    <p className="text-white mt-3">
                      You work directly with the people building the thing. There is no
                      account layer between you and the engineers.
                    </p>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-graduation-cap text-primary" />
                    </div>
                    <h4 className="text-white mt-3">You Keep the Keys</h4>
                    <p className="text-white mt-3">
                      We build on your cloud account and train your team to run it, so you
                      are never locked into us to keep going.
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="justify-content-center mt-5">
                <Col lg="8" className="text-center">
                  <Button
                    className="btn-round"
                    color="white"
                    size="lg"
                    to="/contact"
                    tag={Link}
                  >
                    Tell us what you are working on
                  </Button>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default Landing;
